export const USERNAME_REGEX =
  /^(?!.*(?:\d[-.\s]*){9})([a-zA-Z0-9][a-zA-Z0-9_@-]*)$/i;
